@if (formControl()) {
<div class="role-picker form-group" [formGroup]="formGroup()!">
    <div class="search">
        <mat-form-field class="form-field">
            <input #search matInput [readonly]="$safeNavigationMigration(meta()?.readonly)" [placeholder]="meta().name"
                class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
                @for (group of filtered | async; track group.key) {
                <mat-optgroup [label]="group.key">
                    @for (item of group.items; track item._id) {
                    <mat-option [value]="item">
                        {{item.name}}
                    </mat-option>
                    }
                </mat-optgroup>
                }
            </mat-autocomplete>
            <mat-hint><strong>{{meta().info}}</strong></mat-hint>
            @if (formControl()?.hasError('required')) {
            <mat-error>
                {{meta().name}} is <strong>required</strong>
            </mat-error>
            }
            @if (formControl()?.hasError('form')) {
            <mat-error>
                {{formError}}
            </mat-error>
            }
        </mat-form-field>
    </div>
    <div class="roles"  [formArray]="pickerArray!">
        @for (role of nodes; track role._id; let i = $index) {
        @if (!!role) {
        <mat-form-field class="form-field">
            <input readonly matInput [formControl]="$any($safeNavigationMigration(pickerArray?.at(i)))">
            <button matSuffix mat-icon-button aria-label="Clear" (click)="onDelete(i)">
                <mat-icon>close</mat-icon>
            </button>
            <mat-hint><strong>Role - {{role.name}}</strong></mat-hint>
        </mat-form-field>
        }
        }
    </div>
</div>
}
